module.exports = __webpack_public_path__ + "static/Hero-77beca2c84f900de5de1c907115dc28a.png";